export default __webpack_public_path__ + "static/media/blackcar2.5cac1a27.jpg";